import { Params } from '@angular/router';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface CoreRouterState {
  url: string;
  params: Params;
  queryParams: Params;
  parentRoutePath: string;
}

const coreRouterInitialState: CoreRouterState = {
  url: void 0,
  params: void 0,
  queryParams: void 0,
  parentRoutePath: void 0
};

interface InternalRouterState {
  navigationId: number;
  state: CoreRouterState;
}

const coreInternalRouterState =
  createFeatureSelector<InternalRouterState>('router');

export const selectorCoreRouterState = createSelector(
  coreInternalRouterState,
  state => (state && state.state) || coreRouterInitialState
);

export const selectorCoreRouterUrl = createSelector(
  selectorCoreRouterState,
  state => state.url
);
export const selectorCoreRouterParams = createSelector(
  selectorCoreRouterState,
  state => state.params
);
export const selectorCoreRouterQueryParams = createSelector(
  selectorCoreRouterState,
  state => state.queryParams
);
export const selectorCoreRouterParentRoutePath = createSelector(
  selectorCoreRouterState,
  state => state.parentRoutePath
);
